import { ApiClient } from './ApiClient';
import { IDam, ICreateDamRequest } from '../interfaces/IUser';

class DamService {
  private apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this.apiClient = apiClient;
  }

  async getAllDams(): Promise<IDam[]> {
    try {
      const data = await this.apiClient.get<IDam[]>('/dams');
      return data || [];
    } catch (error) {
      console.error('Error fetching dams:', error);
      throw error;
    }
  }

  async getDamById(id: string): Promise<IDam> {
    try {
      const data = await this.apiClient.get<IDam>(`/dams/${id}`);
      return data;
    } catch (error) {
      console.error('Error fetching dam:', error);
      throw error;
    }
  }

  async createDam(data: ICreateDamRequest): Promise<IDam> {
    try {
      const created = await this.apiClient.post<IDam>('/dams', data);
      return created;
    } catch (error) {
      console.error('Error creating dam:', error);
      throw error;
    }
  }

  async updateDam(id: string, data: Partial<IDam>): Promise<IDam> {
    try {
      const updated = await this.apiClient.put<IDam>(`/dams/${id}`, data);
      return updated;
    } catch (error) {
      console.error('Error updating dam:', error);
      throw error;
    }
  }

  async deleteDam(id: string): Promise<void> {
    try {
      await this.apiClient.delete(`/dams/${id}`);
    } catch (error) {
      console.error('Error deleting dam:', error);
      throw error;
    }
  }

  async getUserCount(damId: string): Promise<number> {
    try {
      const data = await this.apiClient.get<{ damId: string; userCount: number }>(
        `/dams/${damId}/user-count`
      );
      return data.userCount;
    } catch (error) {
      console.error('Error fetching user count:', error);
      throw error;
    }
  }
}

export default DamService;
